import { render, staticRenderFns } from "./studentBillAdjustments.vue?vue&type=template&id=3dcd84e6&scoped=true"
import script from "./studentBillAdjustments.vue?vue&type=script&lang=js"
export * from "./studentBillAdjustments.vue?vue&type=script&lang=js"
import style0 from "./studentBillAdjustments.vue?vue&type=style&index=0&id=3dcd84e6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dcd84e6",
  null
  
)

export default component.exports